import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://oxxuvfjoivgtzvzemtpe.supabase.co";
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY;

const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    storage: window.localStorage,
  },
});

export default supabase;
